<template>
  <div>
    <end-trip-modal />
    <CancelTripModal
      :text="cancellationText"
      :cancel-cb="cancelHandler"
    />
    <b-card>
      <b-card-title>
        <h3>Actions</h3>
      </b-card-title>
      <div
        v-if="tripTriggers.includes('cancel')"
      >
        <h2>Cancellation</h2>
        <div
          class="d-flex justify-content-between"
        >
          <div class="d-flex align-items-center">
            <b-form-radio
              v-if="trip.state === 'ACCEPTED' || trip.state === 'ARRIVED'"
              v-model="selectedAction"
              class="mr-1"
              name="cancel-radio"
              value="feeOnUser"
              @change="cancellationText = FEE_ON_USER"
            >
              {{ FEE_ON_USER }}
            </b-form-radio>
            <b-form-radio
              v-if="trip.state === 'ACCEPTED'"
              v-model="selectedAction"
              class="mr-1"
              name="cancel-radio"
              value="feeOnDriverWithReAssign"
              @change="cancellationText = FEE_ON_DRIVER_WITH_RE_ASSIGN"
            >
              {{ FEE_ON_DRIVER_WITH_RE_ASSIGN }}
            </b-form-radio>
            <b-form-radio
              v-if="trip.state === 'ACCEPTED' || trip.state === 'ARRIVED'"
              v-model="selectedAction"
              class="mr-1"
              name="cancel-radio"
              value="noFee"
              @change="cancellationText = NO_FEE"
            >
              {{ NO_FEE }}
            </b-form-radio>
            <b-form-radio
              v-if="trip.state === 'ACCEPTED' || trip.state === 'ARRIVED'"
              v-model="selectedAction"
              class="mr-1"
              name="cancel-radio"
              value="feeOnDriverWithoutReAssign"
              @change="cancellationText = FEE_ON_DRIVER_WITHOUT_RE_ASSIGN"
            >
              {{ FEE_ON_DRIVER_WITHOUT_RE_ASSIGN }}
            </b-form-radio>
            <b-form-radio
              v-if="trip.state === 'ACCEPTED'"
              v-model="selectedAction"
              class="mr-1"
              name="cancel-radio"
              value="noFeeOnDriverWithReAssign"
              @change="cancellationText = NO_FEE_ON_DRIVER_WITH_RE_ASSIGN"
            >
              {{ NO_FEE_ON_DRIVER_WITH_RE_ASSIGN }}
            </b-form-radio>
          </div>
          <b-button
            variant="primary"
            :disabled="!selectedAction || (!cancelationReasons && optionsd)"
            @click="openCancelModal"
          >
            Submit
          </b-button>
        </div>
        <b-form-group
          label="cancelation reason"
          label-for="test-cancelation-reason"
          class="pt-3"
        >
          <v-select
            v-model="cancelationReasons"
            :options="optionsd"
            class="w-50"
          />
        </b-form-group>
        <b-button
          v-if="tripTriggers.includes('arrive')"
          class="mt-1"
          variant="primary"
          @click="applyTripAction('arrive')"
        >
          Arrive
        </b-button>
      </div>
      <b-button
        v-if="tripTriggers.includes('start')"
        class="mt-2"
        variant="success"
        @click="applyTripAction('start')"
      >
        Start trip
      </b-button>
      <b-button
        v-if="tripTriggers.includes('end')"
        class="mt-2"
        variant="danger"
        @click="openEndTripModal"
      >
        End trip
      </b-button>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCardTitle, BButton, BFormRadio, BFormGroup,
} from 'bootstrap-vue'
import { inject, ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import EndTripModal from './components/EndTripModal.vue'
import CancelTripModal from './components/CancelTripModal.vue'

export default {
  components: {
    BCard,
    BCardTitle,
    BFormRadio,
    EndTripModal,
    CancelTripModal,
    BButton,
    vSelect,
    BFormGroup,
  },
  props: {
    tripTriggers: {
      type: Array,
      default: () => [],
    },
  },
  setup(_, ctx) {
    const trip = inject('trip')
    const FEE_ON_USER = 'With Fee on user'
    const FEE_ON_DRIVER_WITH_RE_ASSIGN = 'With a fee on the driver with a new dispatch'
    const NO_FEE = 'Without fee on user and driver'
    const FEE_ON_DRIVER_WITHOUT_RE_ASSIGN = 'With a fee on the driver without new dispatch'
    const NO_FEE_ON_DRIVER_WITH_RE_ASSIGN = 'Without fee on the driver with a new dispatch'
    const cancellationText = ref('')
    const cancelationReasons = ref('')
    const optionsd = ref([])
    const selectedAction = ref(null)
    const applyTripAction = async action => {
      await ctx.root.$store.dispatch('trips/applyActionOnTrip', {
        action,
        actionDescription: selectedAction.value ? selectedAction.value : undefined,
        cancellation_reason_id: cancelationReasons.value.id,
      })
    }
    const TripAction = async () => {
      const tripId = trip.value.id
      const result = await ctx.root.$store.dispatch('trips/fetchCancelationReasons', { tripId })
      optionsd.value = result.data.data.reasons
      return result
    }
    TripAction()
    const openEndTripModal = () => {
      ctx.root.$bvModal.show('end-trip-modal')
    }
    const openCancelModal = () => ctx.root.$bvModal.show('cancel-trip-modal')
    const cancelHandler = async () => {
      await applyTripAction('cancel')
    }
    return {
      trip,
      selectedAction,
      openCancelModal,
      applyTripAction,
      openEndTripModal,
      cancellationText,
      FEE_ON_USER,
      FEE_ON_DRIVER_WITH_RE_ASSIGN,
      NO_FEE,
      FEE_ON_DRIVER_WITHOUT_RE_ASSIGN,
      NO_FEE_ON_DRIVER_WITH_RE_ASSIGN,
      cancelHandler,
      cancelationReasons,
      optionsd,
    }
  },
}
</script>
<style>
</style>

<!-- :disabled="!selectedAction || (!cancelationReasons && optionsd)" -->
